import { render, staticRenderFns } from "./VeneerLogInfo.vue?vue&type=template&id=45e0ee02&"
import script from "./VeneerLogInfo.vue?vue&type=script&lang=js&"
export * from "./VeneerLogInfo.vue?vue&type=script&lang=js&"
import style0 from "./VeneerLogInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45e0ee02')) {
      api.createRecord('45e0ee02', component.options)
    } else {
      api.reload('45e0ee02', component.options)
    }
    module.hot.accept("./VeneerLogInfo.vue?vue&type=template&id=45e0ee02&", function () {
      api.rerender('45e0ee02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/common/VeneerLogInfo.vue"
export default component.exports